import React, { useEffect, useState } from "react";
import styles from "./mobile.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, EffectCoverflow } from "swiper/modules";
// import { handleGetVideoDataBySlug } from "../../../../../utils/constants/videoDetails";
// import { Rating } from "@mui/material";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faStar } from "@fortawesome/free-solid-svg-icons";
// // import GooglePlayUsers from "../../Icons/LandingPage/GooglePlayUsers";
// // import RatingStar from "../../Icons/LandingPage/RatingStar";
// import useStore from "../../../../../store/UseStore";
import Gradient1 from "./Gradient1";
import Gradient2 from "./Gradient2";
import Gradient3 from "./Gradient3";
import DownloadTheAppCTA from "../../Common/DownloadTheAppCTA";
import AnimationTexts from "../../MobileCategories/AnimationTexts";
import ScrollingCards from "../../ScrollingCards";

const Mobile = ({ future_ready }) => {
  // const [isAtTop, setIsAtTop] = useState(false);
  // const [seriesList, setSeriesList] = useState([]);
  // const { routeToSeries } = useRouting();
  // const series_list = heroSectionData?.series_list;
  // const title = heroSectionData?.title;
  // const description = heroSectionData?.description;
  // const rating = heroSectionData?.rating;
  // const trusted_title = heroSectionData?.trusted_title;

  // const handleRedirectToSeries = (data) => {
  //   routeToSeries({ slug: data?.slug, seriesId: data?.id });
  // };

  // useEffect for the bottom sticky button when hero section scrolls away from screen
  // useEffect(() => {
  //   // setSeriesList(series_list); // rendering the image's slider on client side
  //   const handleScroll = () => {
  //     const fixedButton = document.getElementById("fixedButton");
  //     if (fixedButton) {
  //       const { top } = fixedButton.getBoundingClientRect();
  //       setIsAtTop(top <= 0);
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  return (
    <>
      {/* <div className={styles.main_container}>
        <h4
          className={`border-2 border-[#42354a] text-center w-fit mx-auto rounded-[15px] p-[5px] px-[15px] py-[10px] text-[14px] font-normal text-[#70ef7b] font-inter ${
            showIphoneBanner ? "mt-[120px]" : "mt-[80px]"
          }`}
        >
          {title}
        </h4>
        <div className={styles.series_container}>
          {seriesList && (
            <div className="w-full mx-auto md:w-[60%]">
              <Swiper
                centeredSlides={true}
                loop={true}
                slidesPerView={3}
                initialSlide={2}
                navigation={false}
                effect="coverflow"
                coverflowEffect={{
                  rotate: 0,
                  stretch: 10,
                  depth: 150,
                  modifier: 2,
                  slideShadows: true,
                }}
                pagination={false}
                modules={[EffectCoverflow, Pagination]}
                style={{
                  height: "100%",
                }}
              >
                {[...Array(2)]
                  .flatMap(() => seriesList ?? [])
                  .map((data, index) => {
                    return (
                      <SwiperSlide key={index} style={{ height: "100%" }}>
                        <a
                          href={`${
                            handleGetVideoDataBySlug({ slug: data?.slug })
                              ? `/details/${data?.slug}`
                              : `/video/${data?.slug}`
                          }`}
                        >
                          <ScreenReaderOnly content={data?.description} />
                          <CustomNextImage
                            src={data?.image}
                            alt="seekho"
                            width={135}
                            height={190}
                            priority={true}
                            className={`${styles.img_card} img_card_custom rounded-[8px]`}
                          />
                        </a>
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          )}
        </div>

        <div>
          <h1 className={styles.description}>
            <span style={{ color: "#FFC632" }}>
              {description?.split("|")[0]}{" "}
            </span>
            {description?.split("|")[1]}
          </h1>

          <div className="w-[70%] mx-auto mt-4" id="fixedButton">
            <DownloadAppOrStartLearning />
          </div>

          <div className="w-[80%] mx-auto mt-4">
            <DownloadTheAppCTA
              onSection="Hero Mobile"
              className="w-full !px-10 !rounded-full font-medium"
            />
          </div>

          <div className={styles.google_play_container}>
            <GooglePlayUsers rating={rating} />
            <Image
              src="/assets/landing/logos_google.webp"
              width={106}
              height={20}
              alt="GooglePlay"
            />
            <div className={styles.rating_with_star}>
              <h6>{rating}</h6>
              <RatingStar />
            </div>
          </div>

          <h6 className="text-[27px] font-normal tracking-wide mt-4 text-center">
            Trusted by 1Cr+ Indians
          </h6>
          <div className="mt-3 w-fit mx-auto">
            <Rating
              className={styles.rating_stars}
              name="half-rating-read"
              defaultValue={4.5}
              precision={0.1}
              readOnly
              icon={
                <FontAwesomeIcon
                  icon={faStar}
                  style={{ fontSize: 20, marginLeft: 4 }}
                />
              }
              emptyIcon={
                <FontAwesomeIcon
                  icon={faStar}
                  style={{ color: "rgba(0,0,0,0)" }}
                />
              }
            />
          </div>
        </div>

        {isAtTop && (
          <div className={styles.download_apk_container}>
            <h6>{trusted_title}</h6>
            <div className="py-3 w-fit mx-auto">Download Now</div>
            <DownloadAppOrStartLearning />
          </div>
        )}

        <BlurredBG className={styles.blurred_prop_1} />
        <BlurredBG className={styles.blurred_prop_2} />
      </div> */}

      {/* New Design */}
      <div className="relative pt-32">
        {/* Gradients - place these first, with lower z-index */}
        <Gradient1 className="absolute -top-1 -right-10 w-[700px] z-0" />
        <Gradient2 className="absolute top-12 -left-4 w-[700px] z-0" />
        <Gradient3 className="absolute right-0 top-50 w-[700px] z-0" />

        {/* Number 1 Badge */}
        <div className="relative flex items-center mx-auto w-fit border-r border-t border-b border-yellow-400 bg-[#2A1C0E] rounded-r-xl pl-[60px] pr-4 py-[2px] shadow-lg z-10">
          <img
            src="/assets/landing/heroSection/Number1.webp"
            alt="Seekho Number 1"
            className="absolute -left-[24px] top-1/2 -translate-y-1/2 w-[75px] h-[75px] object-contain rounded-full bg-black"
          />
          <h6 className="text-[16px] text-left text-white mt-1 leading-[24px]">
            <span className="block text-gray-300 font-normal font-inter">
              India’s No.1
            </span>
            <span className="block font-bold tracking-wider text-white font-inter">
              Edutainment <span className="text-gray-300 font-normal">App</span>
            </span>
          </h6>
        </div>

        <div className="mt-[44px]">
          <AnimationTexts />
        </div>

        <div className="mt-2.5 h-[200px]">
          <ScrollingCards
            title={future_ready?.title}
            series_list={future_ready?.series_list}
            // windowSize={windowSize}
          />
        </div>

        {/* <div className="w-[70%] mx-auto mt-2 relative z-10" id="fixedButton">
          <DownloadTheAppCTA
            className="w-full !rounded-full font-semibold z-10"
            onSection="Mobile hero section"
          />
        </div> */}

        {/* Main Hero Text */}
        {/* <div className="text-center mt-10 w-[70%] mx-auto relative z-10 md:w-[50%]">
          <h6 className="text-[24px] font-inter leading-[36px] text-white/80 md:text-[35px]">
            Ghar Baithe{" "}
            <span className="text-[30px] font-inter text-[#FFC632]">
              Seekho
            </span>{" "}
            Aur{" "}
            <span className="text-[30px] font-inter text-[#FFC632]">Sapne</span>{" "}
            Sach Karo!
          </h6>
        </div> */}

        {/* {isAtTop && ( */}
        <div className={styles.download_apk_container}>
          <h6 className="font-light font-inter pb-1.5">
            <span>
              <FontAwesomeIcon
                icon={faThumbsUp}
                className="text-yellow-500 mr-1"
              />{" "}
            </span>
            1Cr+ users ka bharosa
          </h6>
          <DownloadTheAppCTA
            animate
            className="w-full !rounded-full font-semibold"
            onSection="1Cr+ Sticky Container"
          />
        </div>
        {/* )} */}
      </div>
    </>
  );
};

export default Mobile;
